import { SoftSwissLaunchOptionsDto } from '@/models/softSwissLauchOptions';
import { useEffect } from 'react';
import { useExternalScript } from '@starsoft/common/hooks';
import { Either } from '@starsoft/common/interfaces';
import { CreateBettingSessionDemoOutputDto } from '@/services/dto/betiing-session/create-betting-session-demo-output.dto';
import { DetailedBettingSession } from '@/models/betting-session/detailed';
import { SoftswissLaunchStrategy } from '@/types/local-sg';

export default function useLaunchSlotGame(
  slotSessionData?: Either<
    CreateBettingSessionDemoOutputDto,
    DetailedBettingSession
  >,
) {
  const { isError, isReady } = useExternalScript({
    src: process.env.NEXT_PUBLIC_SOFT_SWISS_LAUNCHER as string,
  });

  function launchSlotGame() {
    if (typeof window === 'undefined' || !isReady || !slotSessionData) {
      return;
    }

    const lauchOptions: SoftSwissLaunchOptionsDto = {
      url: slotSessionData?.gateway?.url,
      strategy: SoftswissLaunchStrategy.Detect,
    };

    window?.sg?.launch({
      target_element: 'slot-target-element',
      launch_options: {
        strategy: lauchOptions.strategy,
        game_launcher_url: lauchOptions.url,
      },
    });
  }

  useEffect(launchSlotGame, [isReady, slotSessionData]);

  return {
    isError,
    isReady,
    launchSlotGame,
  };
}
